export const isCuratedCollectionPage = () => {
  return window.location.pathname.includes('curatedcollections');
};

export const isSearchPage = () => {
  return window.location.pathname.includes('/search');
};

export const isHomePage = () => {
  return !window.location.pathname?.includes('/search');
};

export const isPartnersPage = () => {
  // TODO: add proper check for each page, do not rely on class name
  // or path name
  return (
    window.location.pathname?.includes('/partner/') ||
    document.body.classList.contains('brand-index-index')
  );
};

export const isBannersPage = () => {
  return window.location.pathname?.includes('/curatedcollections');
};

export const isCompareGridShown = () => {
  return window.location.search?.includes('compareIds');
};

export const isSharedComparePage = () => {
  return window.location.search?.includes('comparison-table-share-link');
};
